<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <v-tabs
      v-if="tabs.length > 1"
      v-model="tab"
      grow>

      <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
        {{ $t(tab.tabMenu) }}
      </v-tab>

      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
        class="grey lighten-4"
        v-for="(tab, index) in tabs"
        :key="`item-${index}`"
        :value="tab.route">
        <router-view />
      </v-tab-item>

    </v-tabs>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Production',
  data () {
    return {
      tab: null
    }
  },
  mounted () {
    this.tab = this.tabs[0].route
    this.$router.push(this.tabs[0].route)
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'menu.production.production', name: 'Production', route: `/${this.area}/production/subrecipes`, roles: ['manager', 'buyer', 'chef'] },
        { tabMenu: 'menu.production.decrease', name: 'Drecrease', route: `/${this.area}/production/decrease`, roles: ['manager'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    },
    area () {
      return this.$route.params.area
    }
  },
  watch: {
    area (val) {
      this.tab = this.tabs[0].route
      this.$router.push(this.tabs[0].route)
    }
  }
}
</script>
